import { Component } from '@angular/core';

@Component({
  selector: 'app-key-backup',
  templateUrl: './key-backup.component.html',
  styleUrls: ['./key-backup.component.scss']
})
export class KeyBackupComponent {

}
